<!-- <app-expandpanel panelTitle="MapIndy" [parent]="true" [isExpanded]="true" (expandOutput)="onPanelExpanded($event)"
  arrow_icon="keyboard_arrow_up">
  <app-expandpanel panelTitle="Overview" (expandOutput)="onPanelExpanded($event)" [isExpanded]="true"
    parentTitle="MapIndy" arrow_icon="keyboard_arrow_up">
    <h3>Overview</h3>
    <span>MapIndy is an online tool that displays general Indianapolis & property related information. It allows users
      to perform address/parcel searches, include various layers, choose the basemap, measure, retrieve information on
      features, Print the map, & display oblique imagery (Pictometry). Additionally, you can easily switch between
      MapIndy and other online tools; Zoning Browser, Stormwater Impervious Areas, & the Mapping Application for Public
      Safety (MAPS).</span>
  </app-expandpanel>
  <app-expandpanel panelTitle="Main View" (expandOutput)="onPanelExpanded($event)" parentTitle="MapIndy">
    <h3>Main view</h3>
    <span>MapIndy is an online tool that displays general Indianapolis & property related information. It allows users
      to perform address/parcel searches, include various layers, choose the basemap, measure, retrieve information on
      features, Print the map, & display oblique imagery (Pictometry). Additionally, you can easily switch between
      MapIndy and other online tools; Zoning Browser, Stormwater Impervious Areas, & the Mapping Application for Public
      Safety (MAPS).</span><br />
    <img src="assets/image001.jpg" />
  </app-expandpanel>
</app-expandpanel> -->
<app-expandpanel *ngFor="let pc of panelsContent" panelTitle="{{pc.title}}" [isExpanded]="pc.isExpanded" [parent]="true"
  (expandOutput)="onPanelExpanded($event)">
  <app-expandpanel *ngFor="let dir of pc.directories" panelTitle="{{dir.title}}" [isExpanded]="dir.isExpanded"
    parentPanel="pc" (expandOutput)="onPanelExpanded($event)">
    <div [innerHtml]="dir.content"></div><br />
    <app-expandpanel *ngFor="let subdir of dir.directories" panelTitle="{{subdir.title}}"
      [isExpanded]="subdir.isExpanded" (expandOutput)="onPanelExpanded($event)" parentPanel="dir">
      <div [innerHtml]="subdir.content"></div><br />
      <app-expandpanel *ngFor="let subsubdir of subdir.directories" panelTitle="{{subsubdir.title}}"
        [isExpanded]="subsubdir.isExpanded" (expandOutput)="onPanelExpanded($event)" parentPanel="subdir">
        <div [innerHtml]="subsubdir.content"></div>
        <app-expandpanel *ngFor="let subsubsubdir of subsubdir.directories" panelTitle="{{subsubsubdir.title}}"
          [isExpanded]="subsubsubdir.isExpanded" (expandOutput)="onPanelExpanded($event)" parentPanel="subsubdir">
          <div [innerHtml]="subsubsubdir.content"></div>
          <app-expandpanel *ngFor="let subsubsubsubdir of subsubsubdir.directories" panelTitle="{{subsubsubsubdir.title}}"
            [isExpanded]="subsubsubsubdir.isExpanded" (expandOutput)="onPanelExpanded($event)" parentPanel="subsubsubdir">
            <div [innerHtml]="subsubsubsubdir.content"></div>
          </app-expandpanel>
        </app-expandpanel>
      </app-expandpanel>
    </app-expandpanel>
  </app-expandpanel>
  <router-outlet></router-outlet>